<!--
 * @Description: 控制台/日志监控
 * @Author: yingbin
 * @Date: 2019-08-29 15:08:15
 * @LastEditTime: 2019-09-17 13:39:03
 * @LastEditors: yingbin
 -->
<template>
  <div class="logMonitoring">
    <div class="title">
      <div>基础问题</div>
    </div>
    <div class="search">
      <div class="v-input">
        <div class="label">应用名称：</div>
        <div class="input">
          <el-input v-model="appName" placeholder="请输入应用名称"></el-input>
        </div>
      </div>
      <div class="v-input">
        <div class="label">请求时间：</div>
        <div class="input">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
      </div>
      <div class="btns">
        <div class="btn _search">查询</div>
        <div class="btn">重置</div>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border="" style="width: 100%;min-height: calc(100vh - 420px)">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="date" label="应用名称" width="110"></el-table-column>
        <el-table-column prop="name" label="API" width="117"></el-table-column>
        <el-table-column prop="address" label="应用状态" width="120">
          <template slot-scope="scope">
            <div></div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="调用次" width="110"></el-table-column>
        <el-table-column prop="date" label="成功次" width="110"></el-table-column>
        <el-table-column prop="name" label="失败次" width="110"></el-table-column>
        <el-table-column prop="name" label="失败次"></el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background=""
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30]"
          :page-size="100"
          layout="sizes, prev, pager, next, jumper, total"
          :total="400"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import controlApi from "@/apis/control";
export default {
  data() {
    return {
      beginTime: "",
      endTime: "",
      appName: "",
      date: "",

      table_total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: []
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 查询日志信息
    query() {
      this.getLogoInfos();
    },
    // 重置搜索信息
    rest() {},
    getLogoInfos() {},
    // 改变每页显示条数
    sizeChange(e) {
      this.pageSize = e;
      this.getAppList();
      console.log(e);
    },
    // 当前页
    currentChange(e) {
      this.currentPage = e;
      this.getAppList();
      console.log(e);
    }
  }
};
</script>
<style lang="less" scoped>
.logMonitoring {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      height: 1px;
      left: 0px;
      right: 0px;
      bottom: 0;
      background: #ebebec;
    }

    div {
      font-size: 16px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
  }

  .search {
    display: flex;
    padding: 20px 0;

    .v-input {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333333;
      padding-right: 30px;
    }

    .btns {
      display: flex;
      align-items: center;

      .btn {
        width: 60px;
        height: 30px;
        font-size: 14px;
        border-radius: 2px;
        color: #fabe00;
        background: #fff;
        border: 1px solid #fabe00;
        text-align: center;
        line-height: 30px;
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
        cursor: pointer;
      }
      ._search {
        color: #333333;
        border: 1px solid #fabe00;
        background: #fabe00;
        margin-right: 15px;
      }
    }
  }

  .table {
    /deep/th {
      background: #fafafa;
      color: #333333;
      font-weight: normal;
    }

    .page {
      padding: 25px 0;
      display: flex;
      justify-content: flex-end;

      /deep/.el-pagination__total {
        line-height: 30px;
        padding-left: 15px;
      }

      /deep/.el-pager {
        /deep/li {
          background: #fff;
          border: 1px solid #ebebec;
          line-height: 28px;
          font-weight: normal;
        }
        /deep/.active {
          background: #fabe00;
          border-color: #fabe00;
        }
      }
      /deep/.btn-prev,
      /deep/.btn-next {
        background: #fff;
        border: 1px solid #ebebec;
      }
    }
  }
}
</style>